<template>
  <div id="blade4">
    <GroupContainer :obj="stObj.gC">
      <template slot="slot1">
        <TwelveCol>
          <template slot="slot1">
            <svg
              version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xmlns="http://www.w3.org/2000/svg"
              width="0"
              height="0"
            >
              <symbol id="quotebg">
                <path
                  d="M2.0648 17.9084C3.43999 14.4545 5.32408 11.5169 7.72114 9.09122C10.1141 6.54578 13.0776 4.48612 16.61 2.90896C20.1383 1.33509 23.7023 0.362697 27.2946 0L27.2946 10.5445C23.819 11.6367 20.8296 13.6372 18.3158 16.5454C15.8013 19.4552 14.5444 22.909 14.5444 26.9093L26.7549 26.9093L26.7549 54L0 54L0 30.1818C0 25.4544 0.687188 21.3638 2.0648 17.9084"
                  id="Path1"
                  fill="#000000"
                  stroke="solid"
                />
              </symbol>
              <symbol id="quotemd">
                <path
                  d="M0.952987 8.2654C1.58769 6.67133 2.45727 5.31547 3.5636 4.19595C4.66806 3.02113 6.03583 2.07052 7.66616 1.3426C9.29461 0.616193 10.9395 0.167399 12.5975 0L12.5975 4.86668C10.9934 5.37077 9.61364 6.29411 8.45345 7.63633C7.29289 8.97931 6.7128 10.5734 6.7128 12.4197L12.3484 12.4197L12.3484 24.9231L0 24.9231L0 13.9301C0 11.7482 0.317163 9.86023 0.952987 8.2654"
                  id="Path"
                  fill="#000000"
                  stroke="solid"
                />
              </symbol>
              <symbol id="quotesm">
                <path
                  d="M0.635324 5.51027C1.05846 4.44755 1.63818 3.54365 2.37573 2.7973C3.11204 2.01409 4.02389 1.38034 5.11077 0.895065C6.19641 0.410796 7.29302 0.111599 8.39835 0L8.39835 3.24445C7.32892 3.58051 6.4091 4.19607 5.63564 5.09089C4.86193 5.9862 4.4752 7.04892 4.4752 8.27979L8.23229 8.27979L8.23229 16.6154L0 16.6154L0 9.28671C0 7.83213 0.211442 6.57349 0.635324 5.51027"
                  id="Path"
                  fill="#000000"
                  stroke="solid"
                />
              </symbol>
            </svg>

            <div class="col div1" slot="slot1">
              <h2
                class="blade-4-headline"
                slot="slot1"
                v-html="stObj.title"
                data-aos="fade-left"
                data-aos-delay="1000"
              ></h2>
            </div>
            <div slot="slot2" class="div2">
              <p
                class="body blade-3-p"
                v-for="(p, index) in stObj.paragraphs"
                v-html="p"
                :key="`blade3-p-${index}`"
                data-aos="fade-up"
                data-aos-delay="1500"
              ></p>
            </div>

            <h2
              class="blade-4-see"
              slot="slot2"
              v-html="stObj.seeTitle"
              data-aos="fade-left"
              data-aos-delay="2000"
            ></h2>

            <button
              tabindex="2"
              id="show-modal"
              @click="showModal = true"
              class="vz-button-link"
              data-loc="Content:Button:Verizon and AWS improve Orion’s performance"
            >Edge and Amazon Web Services: Video Transcript</button>
            <TranscriptModal v-if="showModal" @close="showModal = false"></TranscriptModal>

            <div class="phone" data-aos="fade-up" data-aos-delay="2000">
              <b-embed
                type="video"
                aspect="16by9"
                :poster="stObj.showcasePlaceholder"
                :src="stObj.showcase"
                id="devVideo"
                controlslist="nodownload noremoteplayback"
                disablepictureinpicture
              >
                <track :src="stObj.closedCaptioning" label="English" kind="captions" srclang="en" />
              </b-embed>

              <div
                @keyup.enter="playClick"
                class="playvideo vz-button-link"
                @click="playClick"
                id="devVideoPlayButton"
                :aria-label="stObj.playVideoTitle"
                data-loc="Content:Button:Verizon and AWS improve Orion’s performance:Play video"
              >
                <svg
                  id="svg1"
                  width="95px"
                  height="95px"
                  viewBox="0 0 95 95"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 47.0254C0 21.0517 21.0517 0 47.0254 0C72.9992 0 94.0509 21.0517 94.0509 47.0254C94.0509 72.9992 72.9992 94.0509 47.0254 94.0509C21.0517 94.0509 0 72.9992 0 47.0254ZM88.1727 47.0254C88.1727 24.3383 69.7126 5.87818 47.0254 5.87818C24.3383 5.87818 5.87818 24.3383 5.87818 47.0254C5.87818 69.7126 24.3383 88.1727 47.0254 88.1727C69.7126 88.1727 88.1727 69.7126 88.1727 47.0254Z"
                    id="Shape"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                    stroke="none"
                  />
                </svg>
                <svg
                  id="svg2"
                  width="44px"
                  height="51px"
                  viewBox="0 0 44 51"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43.2634 25.3937L0 0L0 50.7875L43.2634 25.3937ZM5.76811 40.6321L5.76811 10.1606L31.7272 25.3937L5.76811 40.6321Z"
                    id="Shape"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                    stroke="none"
                  />
                </svg>
                <div 
                  id="playtitle" 
                  @keypress="playClick" 
                  tabindex="4"
                  class="vz-button-link"
                  data-loc="Content:Button:Verizon and AWS improve Orion’s performance">{{ stObj.playVideoTitle }}</div>
              </div>
            </div>
          </template>
        </TwelveCol>
      </template>
    </GroupContainer>

    <div class="row quote" id="duffyquote">
      <img :src="stObj.duffy.background" id="duffybackground" />

      <div class="quoteinternal">
        <div class="col quotes" id="quotes">
          <svg class="quotebg" id="quotebg1" width="28" height="54" viewBox="0 0 28 54">
            <use xlink:href="#quotebg" />
          </svg>
          <svg class="quotebg" id="quotebg2" width="28" height="54" viewBox="0 0 28 54">
            <use xlink:href="#quotebg" />
          </svg>
          <svg class="quotemd" id="quotemd1" width="13" height="25" viewBox="0 0 13 25">
            <use xlink:href="#quotemd" />
          </svg>
          <svg class="quotemd" id="quotemd2" width="13" height="25" viewBox="0 0 13 25">
            <use xlink:href="#quotemd" />
          </svg>
          <svg
            class="quotesm"
            id="quotesm1"
            width="9"
            height="17"
            viewBox="0 0 9 17"
            preserveAspectRatio="xMidYMid meet"
          >
            <use xlink:href="#quotesm" />
          </svg>
          <svg
            class="quotesm"
            id="quotesm2"
            width="9"
            height="17"
            viewBox="0 0 9 17"
            preserveAspectRatio="xMidYMid meet"
          >
            <use xlink:href="#quotesm" />
          </svg>
        </div>

        <div class="col">
          <div id="citation" class="citation">{{ stObj.duffy.text }}</div>

          <div class="duffy2">
            <img :src="stObj.duffy.photo" :alt="stObj.duffy.altText" id="duffyphoto2" />
          </div>

          <div id="citationsignature1" class="citationsignature1">{{ stObj.duffy.name }}</div>
          <div id="citationsignature2" class="citationsignature2">{{ stObj.duffy.title }}</div>
        </div>

        <div class="duffy1">
          <img :src="stObj.duffy.photo" :alt="stObj.duffy.altText" id="duffyphoto1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupContainer from "../../2019-immersive-modular-experience/src/components/GroupContainer";
import TwelveCol from "../../2019-immersive-modular-experience/src/components/TwelveCol";
import TranscriptModal from "../components/TranscriptModal";
import { inView } from "../helpers/inView";
import { duffyAnimation } from "../helpers/blade4";

export default {
  name: "Blade4",
  data: function() {
    return {
      sPW: 0,
      hasAnimated: false,
      showModal: false
    };
  },
  components: {
    GroupContainer,
    TwelveCol,
    TranscriptModal
  },
  computed: {
    stObj() {
      return this.$store.state.blade4;
    }
  },
  methods: {
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#duffyquote", duffyAnimation, "topvisible");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    },
    playClick() {
      let vid = document.getElementById("devVideo");
      vid.play();
      vid.controls = true;

      document.getElementById("devVideoPlayButton").style.display = "none";
    }
  },
  mounted() {
    this.checkInView();
    this.$nextTick(() => {
      document.addEventListener("scroll", this.checkInView);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.checkInView);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade4.scss";
</style>
